import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import useFullscreen from '#/common/hooks/useFullscreen';
import AppMenu from '../components/AppMenu';
import ToastProvider from '../providers/ToastProvider';
import { MenuCollapseProvider, useMenuCollapse } from '../components/AppMenu/MenuCollapseContext';
import useSession from '#/common/hooks/useSession';

const menuBorder = `1px solid ${color('ui', 'middle')}`;

const EXPANDED_MENU_WIDTH = '250px';
const COLLAPSED_MENU_WIDTH = '84px';

const RootLayout: React.FC = () => {
  const { isDesktop } = useViewport();
  const { isFullscreen } = useFullscreen();
  const { isCollapsed } = useMenuCollapse();

  const menuWidth = (() => {
    if (isDesktop) {
      if (isCollapsed) return COLLAPSED_MENU_WIDTH;
      return EXPANDED_MENU_WIDTH;
    }
    return '100%';
  })();

  return (
    <>
      <ToastProvider>
        <NuvoBox display="flex" flexDirection="column" alignItems="center" height="100%">
          <NuvoBox
            width="100%"
            flex="1"
            display="flex"
            flexDirection={isDesktop ? 'row' : 'column-reverse'}
            backgroundColor={color('primary', 'light')}
            style={{
              overflowY: 'hidden',
              overflowX: 'visible',
              position: 'relative',
            }}>
            <NuvoBox
              style={{
                position: isFullscreen ? 'absolute' : 'relative',
                bottom: 0,
                transition: 'transform ease 0.25s, width 0.3s ease',
                transform: `translateY(${isFullscreen ? 74 : 0}px)`,
                overflow: 'visible !important',
                zIndex: 1500,
              }}
              width={menuWidth}
              borderRight={isDesktop ? menuBorder : ''}
              border={isDesktop ? '' : menuBorder}>
              <AppMenu />
            </NuvoBox>
            <NuvoBox flex="1" backgroundColor={color('custom', 'dataGridPageBackground')}>
              <Outlet />
            </NuvoBox>
          </NuvoBox>
        </NuvoBox>
      </ToastProvider>
      <div id="tmm-modal"></div>
    </>
  );
};

const Root: React.FC = () => {
  const { error } = useSession();
  if (error) {
    console.log('root');
    return <Navigate to="/error/no-access" replace />;
  }

  return (
    <MenuCollapseProvider>
      <RootLayout />
    </MenuCollapseProvider>
  );
};

export default React.memo(Root);
